import React, { useState, useCallback } from 'react';

// Hook personalizado para manejar notificaciones
export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'success', duration = 5000) => {
    setNotification({ message, type });
    
    if (duration > 0) {
      setTimeout(() => setNotification(null), duration);
    }
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    hideNotification
  };
};

// Componente de notificación individual
const Notification = ({ notification, onClose }) => {
  if (!notification) return null;

  const { message, type } = notification;

  return (
    <div className={`notification ${type === 'success' ? 'notification-success' : 'notification-error'}`}>
      <div className="notification-content">
        <span className="notification-icon">
          {type === 'success' ? '✅' : '❌'}
        </span>
        <span className="notification-message">{message}</span>
        <button 
          onClick={onClose}
          className="notification-close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

// Componente contenedor del sistema de notificaciones
const NotificationSystem = ({ notification, onClose }) => {
  return (
    <Notification 
      notification={notification} 
      onClose={onClose} 
    />
  );
};

export default NotificationSystem; 